import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { AllState } from '../../../../store'
import { MilestoneDetail } from '../../../../domain/entity/MilestoneEntity'
import { useMilestoneRepository } from '../../../../services/adaptors/milestoneRepositoryAdaptor'
import { featureFlagService } from '../../../../utils/feature-flag'

type UseMilestoneDataResult = {
  milestones: MilestoneDetail[]
  isLoadingMilestones: boolean
  fetchMilestones: () => void
  isMilestoneEnabled: boolean
}

export const useMilestoneData = (): UseMilestoneDataResult => {
  const projectUuid = useSelector((state: AllState) => state.project.selected)
  const milestoneRepository = useMilestoneRepository()
  const [milestones, setMilestones] = useState<MilestoneDetail[]>([])
  const [isLoadingMilestones, setIsLoadingMilestones] = useState(false)

  const isMilestoneEnabled = featureFlagService.isEnabled('milestone')

  const fetchMilestones = useCallback(async () => {
    if (!projectUuid || !isMilestoneEnabled) return
    setIsLoadingMilestones(true)
    try {
      const data = await milestoneRepository.fetchAll()
      setMilestones(data)
    } finally {
      setIsLoadingMilestones(false)
    }
  }, [projectUuid, milestoneRepository, isMilestoneEnabled])

  useEffect(() => {
    fetchMilestones()
  }, [fetchMilestones])

  return {
    milestones,
    isLoadingMilestones,
    fetchMilestones,
    isMilestoneEnabled,
  }
}
